"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelViewer = void 0;
const RunWhenVisible_1 = require("../utils/RunWhenVisible");
class ModelViewer {
    constructor() {
        const element = document.querySelector('model-viewer');
        if (element) {
            (0, RunWhenVisible_1.RunWhenVisible)(element, ModelViewer.injectScript);
        }
    }
    static async injectScript() {
        const modelViewer = document.createElement('script');
        modelViewer.type = 'module';
        modelViewer.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
        document.body.appendChild(modelViewer);
    }
}
exports.ModelViewer = ModelViewer;
